import React from 'react';
import {connect} from 'react-redux';
import {FormattedHTMLMessage} from 'react-intl';
import AdvancedSearch from "../../search/containers/AdvancedSearch";

class Home extends React.Component {
  render() {
    let {location, params} = this.props;
    return (
      <div>
        <div className="home">
          <div className="row border-between">
            <div className="col-sm-8 col-sm-offset-1">
              <p><FormattedHTMLMessage id="diaIntro"/></p>
            </div>
          </div>
        </div>
        <AdvancedSearch location={location} params={params}/>
          {/*<div className="row row-dark">*/}
            {/*<div className="col-sm-12">*/}
              {/*<AnnotatedTexts/>*/}
            {/*</div>*/}
          {/*</div>*/}
          {/*<div className="row">*/}
            {/*<div className="col-sm-12">*/}
              {/*<LastAdjustments/>*/}
            {/*</div>*/}
          {/*</div>*/}
      </div>
    );
  }
}

Home.propTypes = {
  params: React.PropTypes.object,
  location: React.PropTypes.object,
};

export default connect()(Home);



/** WEBPACK FOOTER **
 ** ./src/modules/home/containers/Home.js
 **/